module.exports = __webpack_public_path__ + "uz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/uz.svg
// module id = 871
// module chunks = 0